import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import ar from "./locales/ar.json";

// --- Initialize i18n ---
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ar: { translation: ar },
    },
    lng: localStorage.getItem("lang") || "en", // Default language
    fallbackLng: "en",
    interpolation: { escapeValue: false },
  });

// --- Direction handling ---
const setDocumentDirection = (lng) => {
  document.documentElement.lang = lng;
  document.documentElement.dir = i18n.dir(lng); // "rtl" for Arabic, "ltr" for English
};

setDocumentDirection(i18n.language);

i18n.on("languageChanged", (lng) => {
  localStorage.setItem("lang", lng);
  setDocumentDirection(lng);
});

export default i18n;
